var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.072 1.1487c-0.0783-0.07764-0.1773-0.1314-0.2853-0.15496-0.108-0.023552-0.2205-0.015917-0.3242 0.022005l-12.772 4.6243c-0.11014 0.0416-0.20497 0.11558-0.27189 0.21211-0.066917 0.09654-0.10276 0.21106-0.10276 0.32835 0 0.1173 0.035839 0.23182 0.10276 0.32836 0.066916 0.09653 0.16174 0.17051 0.27189 0.21211l4.9867 1.9827 3.6805-3.6763 0.81858 0.81503-3.698 3.6821 1.997 4.9653c0.04302 0.1076 0.11748 0.1998 0.21374 0.2647 0.09626 0.065 0.20989 0.0996 0.32615 0.0995 0.11732-0.0024 0.23115-0.0401 0.3265-0.1082 0.09534-0.0681 0.16772-0.1634 0.20759-0.2733l4.6442-12.717c0.0396-0.10227 0.0491-0.21362 0.0275-0.32108-0.0216-0.10747-0.0734-0.2066-0.1494-0.28586z",
    fill: "#0D73D9"
  })));
}

export default SvgPlane;